// extracted by mini-css-extract-plugin
module.exports = {"formRow":"AddressForm_formRow__7h6wN","splitRow":"AddressForm_splitRow__1zIGZ","submitButton":"AddressForm_submitButton__2vwzC","error":"AddressForm_error__sYQ8Q"};